import './components/events/init-components-events';
import './components/review/init-review-component';

// import { FilterSort } from './modules/smartfilter/Filter-Sort';

document.addEventListener('DOMContentLoaded', () => {
    // const filterSortElement = document.querySelector('.filter-sort');

    // const eventSort = new FilterSort(filterSortElement);
    // eventSort.standAlone();
});
